import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import Crypto from 'crypto-js';
import Cookie from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const cookieName = Crypto.RIPEMD160(process.env.VUE_APP_MARCA);

const storageKey = Crypto.RIPEMD160(process.env.VUE_APP_MARCA);


import wizard from "./modulos/wizard";
import login from "./modulos/usuario";
import ram from "./modulos/ram";


Vue.use(Vuex);

const encryptionToken = process.env.NODE_ENV==='produccion' ? Cookie.get(cookieName) || uuidv4() : process.env.VUE_APP_MARCA;
Cookie.set(cookieName, encryptionToken, { secure: true, expires: 180 });


const local = new VuexPersistence({
    storage: {
        getItem: () => {
            const store = window.localStorage.getItem(storageKey);
            if (store) {
                try {
                    const bytes = Crypto.AES.decrypt(store, encryptionToken);
                    return JSON.parse(bytes.toString(Crypto.enc.Utf8));
                } catch (e) {
                    window.localStorage.removeItem(storageKey);
                }
            }
            return null;
        },
        setItem: (key, value) => {
            const store = Crypto.AES.encrypt(value, encryptionToken).toString();
            return window.localStorage.setItem(storageKey, store);
        },
        removeItem: () => window.localStorage.removeItem(storageKey),
    },
    modules:['login']
});

const sesion = new VuexPersistence({
    storage: {
        getItem: () => {
            const store = window.sessionStorage.getItem(storageKey);
            if (store) {
                try {
                    const bytes = Crypto.AES.decrypt(store, encryptionToken);
                    return JSON.parse(bytes.toString(Crypto.enc.Utf8));
                } catch (e) {
                    window.sessionStorage.removeItem(storageKey);
                }
            }
            return null;
        },
        setItem: (key, value) => {
            const store = Crypto.AES.encrypt(value, encryptionToken).toString();
            return window.sessionStorage.setItem(storageKey, store);
        },
        removeItem: () => window.sessionStorage.removeItem(storageKey),
    },
    modules:['wizard']
});

const store = new Vuex.Store({
    modules: {
        wizard,
        login,
        ram
    },
    plugins: [local.plugin,sesion.plugin]
});

export default store;
